import { HTMLAttributes, ReactNode } from 'react';
import './Card.css';

interface ICardSlot {
  children: ReactNode;
  className?: string;
}

interface ICardRoot extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

function Root({ children, className, ...rest }: ICardRoot) {
  return (
    <div className={['card', className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </div>
  );
}

function Header({ children, className }: ICardSlot) {
  return (
    <div className={['card__header', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}

function Content({ children, className }: ICardSlot) {
  return (
    <div className={['card__content', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}

function Footer({ children, className }: ICardSlot) {
  return (
    <div className={['card__footer', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}

export const Card = Object.assign(Root, {
  Header,
  Content,
  Footer,
});
